<template>
  <div class="" :style="bg">
    <div class="container">
      <div>
        <img :src="svg" alt="" style="padding: 70px 0;" />
      </div>
      <el-radio-group v-model="radio" @change="tabchange">
        <el-radio-button v-for="(item, index) in sysOptions" :key="index" :label="item.value">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <div class="syslist" style="height:700px;overflow-y: auto;">
        <div id="mes">
          <hr style="border-color:#424242;margin: 5px 0 10px 0;" />
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in meslist" :key="index">
              <div class="sysitem">
                <div class="sysitem__img">
                  <img :src="`http://demo.feixuns.com/images/board/${item.img}`" alt="" />
                </div>
                <div class="sysitem__title" @click="openboard(item)">
                  <span>{{ item.title }}</span>
                  <i class="iconfont icon-shipin1 text-white"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="vps">
          <hr style="border-color:#424242;margin: 5px 0 10px 0;" />
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in vpslist" :key="index">
              <div class="sysitem">
                <div class="sysitem__img">
                  <img :src="`http://demo.feixuns.com/images/board/${item.img}`" alt="" />
                </div>
                <div class="sysitem__title" @click="openboard(item)">
                  <span>{{ item.title }}</span>
                  <i class="iconfont icon-shipin1 text-white"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="qms">
          <hr style="border-color:#424242;margin: 5px 0 10px 0;" />
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in qmslist" :key="index">
              <div class="sysitem">
                <div class="sysitem__img">
                  <img :src="`http://demo.feixuns.com/images/board/${item.img}`" alt="" />
                </div>
                <div class="sysitem__title" @click="openboard(item)">
                  <span>{{ item.title }}</span>
                  <i class="iconfont icon-shipin1 text-white"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="wms">
          <hr style="border-color:#424242;margin: 5px 0 10px 0;" />
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in wmslist" :key="index">
              <div class="sysitem">
                <div class="sysitem__img">
                  <img :src="`http://demo.feixuns.com/images/board/${item.img}`" alt="" />
                </div>
                <div class="sysitem__title" @click="openboard(item)">
                  <span>{{ item.title }}</span>
                  <i class="iconfont icon-shipin1 text-white"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="tpm">
          <hr style="border-color:#424242;margin: 5px 0 10px 0;" />
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in tpmlist" :key="index">
              <div class="sysitem">
                <div class="sysitem__img">
                  <img :src="`http://demo.feixuns.com/images/board/${item.img}`" alt="" />
                </div>
                <div class="sysitem__title" @click="openboard(item)">
                  <span>{{ item.title }}</span>
                  <i class="iconfont icon-shipin1 text-white"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog :title="lookdata.title" class="fullscreen" :visible.sync="dialogVisible" size="tiny">
      <iframe :src="lookdata.src" style="width: 100%; height: 100vh" frameborder="0"></iframe>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
// import Basedemo from "@/components/system/Basedemo.vue";
// import Mesdemo from "@/components/system/Mesdemo.vue";
// import Dccdemo from "@/components/system/Dccdemo.vue";
// import Srmdemo from "@/components/system/Srmdemo.vue";
// import Yunyou from "@/components/system/Yunyou.vue";
// import Yunfan from "@/components/system/Yunfan.vue";
// import Yunzhi from "@/components/system/Yunzhi.vue";
// 引入 doserve 和 formatServerData 函数
import { doserve } from "@/assets/js/serverUtils.js";
import $ from "jquery";
// import Chanping from "@/components/system/Chanping.vue";
// import Otherdemo from "@/components/system/Otherdemo.vue";

// import Wmsdemo from '../components/system/Wmsdemo.vue';

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
  data() {
    return {
      bg: `background:#000 url(${require("../assets/images/demobg.png")}) no-repeat scroll top center/100% 100%;min-height:500px`,
      svg: require("../assets/images/lookdemo.svg"),
      tabPosition: "left",
      radio: "mes",
      sysOptions: [
        {
          label: "生产执行",
          value: "mes",
        },
        {
          label: "计划排程",
          value: "vps",
        },
        {
          label: "品质管理",
          value: "qms",
        },
        {
          label: "仓储管理",
          value: "wms",
        },
        {
          label: "设备管理",
          value: "tpm",
        },
      ],
      meslist: [],
      vpslist: [],
      qmslist: [],
      wmslist: [],
      tpmlist: [],
      dialogVisible: false,
      lookdata: {},
    };
  },
  methods: {
    tabchange() {
      console.log(this.radio);
      console.log("切换了", this.radio);
      let element = document.getElementById(this.radio);
      let parentElement = element.parentNode;

      let childRect = element.getBoundingClientRect();
      // 获取父元素相对于视口的位置
      let parentRect = parentElement.getBoundingClientRect();
      let top = childRect.top - parentRect.top + parentElement.scrollTop;
      console.log("top", top);
      $(".syslist").animate(
        {
          scrollTop: top,
        },
        500
      );
    },
    openboard(item) {
      console.log("item", item);
      this.dialogVisible = true;
      this.lookdata = item;
      // window.open(`/?page=form1&board=${item.id}`, "_self");
    },
  },
  mounted() {
    (async () => {
      // console.log(`我是Mounted生命周期`);
      let res = await doserve("8999-2");
      let data = JSON.parse(JSON.parse(res.jsobj)["1"] || []).filter((item) => item.show === 1);
      // debugger;
      this.meslist = data.filter((item) => item.sys === "mes");
      this.vpslist = data.filter((item) => item.sys === "vps");
      this.qmslist = data.filter((item) => item.sys === "qms");
      this.wmslist = data.filter((item) => item.sys === "wms");
      this.tpmlist = data.filter((item) => item.sys === "tpm");
      // dataRef.tableData.value = formatServerData(res);
    })();
  },
  components: {
    // Basedemo,
    // Chanping,
    // Yunyou,
    // Yunfan,
    // Yunzhi,
    // Mesdemo,
    // Dccdemo,
    // Srmdemo,
    // Otherdemo,
    // Wmsdemo,
    // HelloWorld
  },
};
</script>
<style lang="scss" scoped>
.sysitem {
  background: #1d262e;
  border-radius: 0;
  border: 1px solid rgba(255, 255, 255, 0.3);

  margin-bottom: 20px;
  &__img {
    height: 155px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__title {
    height: 36px;
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    span {
      display: block;
      font-weight: 600;
      font-size: 14px;
      color: #eee;
      text-transform: none;
      margin-bottom: 0;
    }
    i:before {
      color: #eee;
      font-size: 1.25rem;
    }
    &:hover {
      background: #409eff;
    }
  }
}
.syslist {
  margin-top: 50px;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
}
.scrollable-container {
  width: 300px;
  height: 200px;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
<style>
.el-radio-button__inner {
  background-color: #424242;
  border: 1px solid #424242;
  color: #eee;
}
.el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #424242;
}
</style>
